const proTrading = {
    state: {
        // K线静态资源是否加载完成
        klineStatic: false,
        // 行情交易币种
        proSymbol: null,
        // 交易币种精度
        symbolInfo: null,
        // 分区
        areas: [],
        // 新分区（不更新老分区，担心过多地方用到）
        newareas: [],
        // 币币快速交易tabs
        symbols: [],
        // ETF快速交易tabs
        etfSymbols: [],
        //  交易币种列表
        proSymbols: [],
        // 交易最新价
        newPrice: null,
        // ETF净值对象
        netWorth: null,
        //  未过滤的行情列表
        allSymbols: [],
        // 币对精度列表
        coinAccuracyList: [],
        symbolInfoLoading:true
    },
    mutations: {
        // 同步设置K线资源状态
        setKlineStatic(state, boolean) {
            state.klineStatic = boolean
        },
        setProSymbol(state, symbol) {
            state.proSymbol = symbol
        },
        setSymbolInfo(state, symbol) {
            state.symbolInfo = symbol
        },
        setSymbolInfoLoading(state, boolean) {
            state.symbolInfoLoading = boolean
        },
        setAreas(state, areas) {
            state.areas = areas
        },
        setNewAreas(state, areas) {
            state.newareas = areas
        },
        setSymbols(state, symbols) {
            state.symbols = symbols
        },
        setAllSymbols(state, allSymbols) {
            state.allSymbols = allSymbols
        },
        setETFSymbols(state, etfSymbols) {
            state.etfSymbols = etfSymbols
        },
        setProSymbols(state, symbols) {
            state.proSymbols = symbols
        },
        setNewPrice(state, newPrice) {
            state.newPrice = newPrice
        },
        setNetEorth(state, netWorth) {
            state.netWorth = netWorth
        },
        setCoinAccuracyList(state, coinAccuracyList) {
            state.coinAccuracyList = [...coinAccuracyList]
        }
    },
    actions: {
        setKlineStatic({ commit }, boolean) {
            commit('setKlineStatic', boolean)
        },
        setSymbolInfoLoading({ commit }, boolean) {
            commit('setSymbolInfoLoading', boolean)
        },
        setProSymbol({ commit }, {symbol, type}) {
            let symbols
            // 快速交易页 Tabs
            if (type == 'etf') {
                symbols = JSON.parse(localStorage.getItem('etfSymbols'))
            } else {
                symbols = JSON.parse(localStorage.getItem('symbols'))
            }
            if (symbols instanceof Array) {
                let results = symbols.filter((item) => {
                    if (item.tmId == symbol.tmId) return item
                })
                if (results.length == 0) {
                  //添加超过6个时，把最后一个pop出去，保持最多6个
                    if (symbols.length == 6) {
                        symbols.pop()
                    }
                    symbols.unshift(symbol)
                }
            } else {
                symbols = [symbol]
            }
            if (type == 'etf') {
                localStorage.setItem('etfSymbols', JSON.stringify(symbols))
                commit('setETFSymbols', symbols)
            } else {
                localStorage.setItem('symbols', JSON.stringify(symbols))
                commit('setSymbols', symbols)
            }
            commit('setProSymbol', symbol)
        },
        setSymbolInfo({ commit }, symbol) {
            commit('setSymbolInfo', symbol)
        },

        setAreas({ commit }, areas) {
            commit('setAreas', areas)
        },
        setNewAreas({ commit }, areas) {
            commit('setNewAreas', areas)
        },
        setSymbols ({ commit, state }, {tmId, type}) {
            let symbols
            // 快速交易页 Tabs
            if (type == 'etf') {
                symbols = state.etfSymbols
            } else {
                symbols = state.symbols
            }
            let results = -1
            symbols.forEach((item, i) => {
                if (item.tmId == tmId) {
                    results = i
                }
            })
            if (results != -1) {
                symbols.splice(results, 1)
            }
            if (type == 'etf') {
                localStorage.setItem('etfSymbols', JSON.stringify(symbols))
                commit('setETFSymbols', symbols)
            } else {
                localStorage.setItem('symbols', JSON.stringify(symbols))
                commit('setSymbols', symbols)
            }
            // 删除当前币种时，默认选择第一个
            if (tmId == state.proSymbol.tmId) {
                commit('setProSymbol', symbols[0])
            }
        },
        setAllSymbols({ commit }, allSymbols) {
            commit('setAllSymbols', allSymbols)
        },
        setProSymbols({ commit }, symbols) {
            commit('setProSymbols', symbols)
        },
        setNewPrice({ commit }, newPrice) {
            commit('setNewPrice', newPrice)
        },
        setNetWorth({ commit }, netWorth) {
            commit('setNetEorth', netWorth)
        },
        setCoinAccuracyList({ commit }, coinAccuracyList) {
            commit('setCoinAccuracyList', coinAccuracyList)
        },

    },
    getters: {
        getSymbolInfoLoading(state) {
            return state.symbolInfoLoading 
        },
        getCoinAccuracyList(state) {
            return state.coinAccuracyList
        },
        getKlineStatic(state) {
            return state.klineStatic
        },
        getProSymbol(state) {
            return state.proSymbol
        },
        getSymbolInfo(state) {
            return state.symbolInfo
        },
        getAreas(state) {
            return state.areas
        },
        getNewAreas(state) {
            return state.newareas
        },
        getSymbols(state) {
            return state.symbols
        },
        getAllSymbols(state) {
            return state.allSymbols
        },
        getETFSymbols(state) {
            return state.etfSymbols
        },
        getProSymbols(state) {
            return state.proSymbols
        },
        getNewPrice(state) {
            return state.newPrice
        },
        getNetWorth(state) {
            return state.netWorth
        }
    }
}

export default proTrading



// WEBPACK FOOTER //
// ./src/store/proTrading/index.js